var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"evaluation-button",attrs:{"color":"primary","loading":_vm.loading},on:{"click":_vm.generatePdf}},[_c('v-icon',{staticClass:"mr-1"},[_vm._v(_vm._s(_vm.buttonIcon))]),_c('p',{staticClass:"pt-1 ma-0"},[_vm._v(_vm._s(_vm.buttonText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }